import type { FC } from "react";

import { TerminalProfilesSearchForm } from "src/app/features/TerminalProfile/components/forms/TerminalProfilesSearchForm";
import { TerminalProfilesTable } from "src/app/features/TerminalProfile/components/tables/TerminalProfilesTable";
import type { TerminalProfileList } from "src/app/features/TerminalProfile/types/TerminalProfileList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const TerminalProfilesPage: FC<NoneOwnProps> = () => {
    const table = <TerminalProfilesTable />;
    const searchForm = <TerminalProfilesSearchForm />;
    const hasAccess = canAccess(ResourceName.TERMINAL_PROFILES, "canRead");

    return (
        <PageLayout name="terminalProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.terminalProfiles" />
                    <ResourceManager<TerminalProfileList>
                        useDataGroup
                        dataMapperKey="terminalProfilesTableData"
                        resource={ResourceName.TERMINAL_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
